const serviceUnavailable = 'Сервис временно недоступен. Ведутся технические работы'
const reload = 'Обновите страницу'

export {
    serviceUnavailable,
    reload
}